const env = process.env;
const rawAddress = (env.REACT_APP_CONTRACT_ADDRESS || "").trim();
const isValidAddress = (a) => /^0x[a-fA-F0-9]{40}$/.test(a);

export const config = {
  name: "学无界",
  nameEn: "Xue Wujie",
  taglineZh: "让教育没有边界",
  taglineEn: "Learn Without Borders",
  mission: "让每一个孩子，都有免费学习的机会。",
  siteUrl: env.REACT_APP_SITE_URL,
  apiUrl: `${env.REACT_APP_BACKEND_URL}/api`,
  social: { x: "https://x.com/xuewujie", xHandle: "@xuewujie" },
  token: {
    proposedTicker: "XUE",
    chain: { name: "BNB Smart Chain", chainId: 56, chainIdHex: "0x38", explorer: "https://bscscan.com", confirmed: true },
    contractAddress: isValidAddress(rawAddress) ? rawAddress : null,
    launched: env.REACT_APP_TOKEN_LAUNCHED === "true" && isValidAddress(rawAddress),
    buyUrl: "https://flap.sh/",
    chartUrl: "https://dexscreener.com/",
    tokenBuyUrl: "https://flap.sh/bnb/0x90cf640a0747ad2dadc5bc88a5269b9f6b5e7777",
    tokenChartUrl: "https://dexscreener.com/bsc/0xb3e8328849fabf95f043aee71ac1e8e8e73b6963",
    tokenomics: null,
  },
  features: { web3: true, aiTutor: true, donations: false, newsletter: false, emailDelivery: false, liveXFeed: false },
  contact: { email: null },
  languages: [
    { code: "zh-CN", label: "简体中文", short: "中" },
    { code: "en", label: "English", short: "EN" },
  ],
  defaultLanguage: "zh-CN",
  analytics: { provider: null, enabled: false },
};

export const explorerAddressUrl = (a) => `${config.token.chain.explorer}/token/${a}`;
